import { render, staticRenderFns } from "./CreateDatabaseDialog.vue?vue&type=template&id=72adc00c&"
import script from "./CreateDatabaseDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateDatabaseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports